import axios from 'axios';
// import store from '../store';

const API_URL = '/api/avail';

const config = {
  baseURL: API_URL,
  timeout: 10000,
  headers: {
    // withCredentials: true,
    'Content-Type': 'application/json'
  }
}

const AXIOS = axios.create(config);


/**
 * Request Interceptor to set Authorization Token if present in localStorage
 */
AXIOS.interceptors.request.use(function (config) {
  // Do something before request is sent
  let token = localStorage.getItem('token');

  if (token !== null) {
    config.headers['Authorization'] = 'Bearer ' + token;
  }

  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

/**
 * Response Interceptor to Check for 302 or 401 or 403 states in responses and
 * perform "logout" if one occurs
 */
AXIOS.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data

  // we need this because spring boot and session thing is redirecting instead of return 401
  if (response.data && typeof response.data === 'string' && response.data.startsWith('<!DOCTYPE html>')) {
    window.location = '/signin';
  }

  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  console.log("response error", error)

  switch (error.response.status) {
    case 401:
    case 403: //store.dispatch("auth/logout");
      console.log("LOGOUT!");
      // window.location = '/signin';
      break;
    default:
      return Promise.reject(error);
  }
});

export default AXIOS;
